import React from 'react';

import {EmbedlyVideo} from './EmbedlyVideo';

import {ProcessorType} from '../node-processors-types';
import {hasHref, isInsidePre, isNotEmpty} from '../node-processors-utils';

// Taken from froala video
const VIDEO_PROVIDER_TESTS = [
  /(((youtu.be)|(youtube.com))\/((v\/)|(\/u\/\w\/)|(embed\/)|(watch\?)))/i,
  /((vimeo.com)\/(channels(\/\w+\/)?|groups\/*\/videos\/.*\d+\/|video\/|)(\d+))/i,
  /(screencast-o-matic.com\/watch\/\w+)/i,
  /(loom.com\/share\/\w+)/i,
  /(loom.com\/embed\/\w+)/i,
];

export const EmbedlyVideoEmbedProcessor: ProcessorType = {
  tag: 'a',
  condition: (node) =>
    hasHref(node) &&
    isNotEmpty(node) &&
    !isInsidePre(node) &&
    isVideoLinkType(node.attribs.href),
  processor: (node, index) => [null, <EmbedlyVideo key={index} node={node} />],
};

const isVideoLinkType = (href: string): boolean => {
  for (let re of VIDEO_PROVIDER_TESTS) {
    if (href.match(re) != null) {
      return true;
    }
  }
  return false;
};
